import axios from 'axios';
import Qs from 'qs'


// if (info.accessToken){
//    head={
//      'Content-Type': 'application/json',
//      'accessToken': info.accessToken
//    }
// } else {
//   head={
//     'Content-Type': 'application/json',
//   }
// }
// http请求


function apiAxios(method, url, params, response,headers) {
  let http;
  if (headers){
    http = axios.create({
      localhost: 'http://localhost:3000/',
      // withCredentials: true,
      headers: headers,
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  }else {
    let info=JSON.parse(localStorage.getItem('userInfo'));
    let accessToken
    if (info) {
      accessToken=info.accessToken;
    }
    var head={
      'Content-Type': 'application/json',
      'accessToken': accessToken,
    };
    http = axios.create({
      baseURL: 'http://localhost:3000/',
      // withCredentials: true,
      headers: head,
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  }
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    if (res.status >= 200 && res.status < 300) {
      response(res.data);
    }
  }).catch(function (err) {
    console.error(err);
  })
}

export default {
  axiosFun: function (api, params, response,headers) {
    return apiAxios(api['method'], api['url'], params, response,headers);
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js